var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6875,
    width: 42.625,
    height: 38.6257,
    rx: 3,
    fill: "#DAE2EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7673 19.1992C19.7808 19.2112 19.7935 19.2225 19.8063 19.236C20.6155 20.0655 21.0618 21.1642 21.0618 22.3305V25.3185L22.7388 24.405C22.8708 24.333 22.9525 24.192 22.9525 24.0367V22.3215C22.9525 21.1597 23.3943 20.0647 24.196 19.2397L27.8238 15.381C28.0585 15.1312 28.1875 14.8035 28.1875 14.4577V13.7557C28.1875 13.4077 27.913 13.125 27.577 13.125H16.4238C16.087 13.125 15.8125 13.4077 15.8125 13.7557V14.4577C15.8125 14.8035 15.9415 15.1312 16.1763 15.3802L19.7673 19.1992ZM20.797 26.6257C20.6455 26.6257 20.4955 26.5852 20.359 26.5042C20.095 26.3467 19.9368 26.0685 19.9368 25.7595V22.3305C19.9368 21.4792 19.6195 20.6775 19.0413 20.0632C19.024 20.049 19.0068 20.0332 18.9918 20.0167L15.3573 16.152C14.9253 15.693 14.6875 15.0907 14.6875 14.4577V13.7557C14.6875 12.7875 15.4667 12 16.4238 12H27.577C28.5332 12 29.3125 12.7875 29.3125 13.7557V14.4577C29.3125 15.09 29.0748 15.6915 28.6443 16.1512L25.009 20.0167C24.4068 20.6377 24.0775 21.4545 24.0775 22.3215V24.0367C24.0775 24.6037 23.7708 25.1227 23.2773 25.3927L21.2065 26.5207C21.0775 26.5905 20.9373 26.6257 20.797 26.6257Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.03e43e857cbf1bfb76b78d356538dc78.svg";
export { ForwardRef as ReactComponent };